import { render } from "./EditPendingCase.vue?vue&type=template&id=0a342bca&scoped=true"
import script from "./EditPendingCase.vue?vue&type=script&lang=js"
export * from "./EditPendingCase.vue?vue&type=script&lang=js"

import "./EditPendingCase.vue?vue&type=style&index=0&id=0a342bca&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a342bca"],['__file',"src/components/pendingCases/EditPendingCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a342bca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a342bca', __exports__)) {
    console.log('reload')
    api.reload('0a342bca', __exports__)
  }
  
  module.hot.accept("./EditPendingCase.vue?vue&type=template&id=0a342bca&scoped=true", () => {
    console.log('re-render')
    api.rerender('0a342bca', render)
  })

}


export default __exports__